import { useAtomValue } from 'jotai';

import { $theme, useSystemColorScheme } from '~/shared/state/preferences.state';

export const useTheme = () => {
  const theme = useAtomValue($theme);
  const systemColorScheme = useSystemColorScheme();

  const effectiveColorScheme = theme.colorScheme ?? systemColorScheme;

  return { effectiveColorScheme };
};
